import { render, staticRenderFns } from "./pick-wn.vue?vue&type=template&id=64acf81a&scoped=true"
import script from "./pick-wn.vue?vue&type=script&lang=ts"
export * from "./pick-wn.vue?vue&type=script&lang=ts"
import style0 from "./pick-wn.vue?vue&type=style&index=0&id=64acf81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64acf81a",
  null
  
)

export default component.exports